/**
 * #/login — sign in without the account bar.
 *
 * The bar is behind a flag, so it must never be the ONLY way in. Every screen the
 * framework provides is reachable by URL.
 */
import { useState } from 'react';
import { useAuth } from '../auth/AuthProvider';
import { LoginForm } from './LoginForm';
import { RegisterForm } from './RegisterForm';

export function LoginScreen({ onClose }: { onClose: () => void }) {
  const { session } = useAuth();
  const [registering, setRegistering] = useState(false);

  return (
    <div className="flags-page">
      <div className="container flags-inner flags-narrow">
        <header className="flags-head">
          <div>
            <h1>{registering ? 'Create an account' : 'Sign in'}</h1>
            <p>
              {session
                ? `Already signed in as ${session.name}.`
                : 'Editors and administrators only. Visitors need no account.'}
            </p>
          </div>
          <button onClick={onClose}>← Back to site</button>
        </header>

        <div className="profile-block">
          {session ? (
            <p className="notice-ok">You are signed in. Head to your profile or back to the site.</p>
          ) : registering ? (
            <RegisterForm toLogin={() => setRegistering(false)} />
          ) : (
            <LoginForm onDone={onClose} toRegister={() => setRegistering(true)} />
          )}
        </div>
      </div>
    </div>
  );
}
